import { Link, useLocation } from "react-router-dom";
import { ShoppingBag, Send, Building2 } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useConfig } from "../context/ConfigContext";

const btn = "flex-1 h-12 font-display tracking-wider text-sm inline-flex items-center justify-center gap-2";

export const MobileOrderBar = () => {
  const { pathname } = useLocation();
  const { totals, setOpen } = useCart();
  const { ecommerceEnabled } = useConfig();
  const onShop = pathname === "/shop";

  return (
    <>
      <div className="h-28 md:hidden" />
      <div data-testid="mobile-order-bar" className="md:hidden fixed z-[80] bottom-0 inset-x-0 bg-[#050505]/90 backdrop-blur-xl border-t border-[var(--tha-border)] px-3 py-2 flex gap-2">
        {ecommerceEnabled ? (
          <>
            {onShop && totals.count > 0 ? (
              <button data-testid="mobile-order-bar-checkout" onClick={() => setOpen(true)} className={`btn-red ${btn}`}>
                <ShoppingBag size={16} /> NAAR MANDJE · € {totals.subtotal.toFixed(2)}
              </button>
            ) : (
              <Link to="/shop" data-testid="mobile-order-bar-order" className={`btn-red ${btn}`}>
                <ShoppingBag size={16} /> BESTEL NU
              </Link>
            )}
            <button data-testid="mobile-order-bar-cart" onClick={() => setOpen(true)} aria-label="Winkelmandje" className="relative w-12 h-12 border border-[var(--tha-border)] inline-flex items-center justify-center">
              <ShoppingBag size={18} />
              {totals.count > 0 && (
                <span data-testid="mobile-order-bar-cart-count" className="absolute -top-1.5 -right-1.5 min-w-[20px] h-5 px-1 flex items-center justify-center bg-[var(--tha-red)] text-black text-[10px] font-bold rounded-full">
                  {totals.count}
                </span>
              )}
            </button>
          </>
        ) : onShop ? (
          <Link to="/zakelijk" data-testid="mobile-order-bar-b2b" className={`btn-red ${btn}`}>
            <Building2 size={16} /> ZAKELIJK AANVRAGEN
          </Link>
        ) : (
          <Link to="/shop" data-testid="mobile-order-bar-request" className={`btn-red ${btn}`}>
            <Send size={16} /> BESTELLING AANVRAGEN
          </Link>
        )}
      </div>
    </>
  );
};
